__turbopack_context__.v({
  "amountSumContainer": "TotalDonationAmount-module__hBp4zW__amountSumContainer",
  "impactText": "TotalDonationAmount-module__hBp4zW__impactText",
  "sumLabel": "TotalDonationAmount-module__hBp4zW__sumLabel",
  "sumLabelContainer": "TotalDonationAmount-module__hBp4zW__sumLabelContainer",
});
